
import WebService from "./WebService";
export const GetOutletList = () => {
    return WebService.getAPI({
        action: 'outlet/list/for-dropdown',
        body: null,
    }).then((res: any) => {
        return res?.list;
    }).catch((error: any) => {
    });
}


export const GetCountryList = () => {
    return WebService.getAPI({
        action: 'client/master-countries',
        body: null,
    }).then((res: any) => {
        return res?.list;
    }).catch((error: any) => {
    });
}

export const GetStatesList = (id?: string) => {
    return WebService.getAPI({
        action: 'client/master-states/' + id,
        body: null,
    }).then((res: any) => {
        return res?.list;
    }).catch((error: any) => {
    });
}

export const getMenuPermissions = () => {
    return WebService.getAPI({
        action: 'staffs/my-menu-permissions',
        body: null,
    })
}

export const ExportExcel = (apiUrl: string, queryString: any, body: any, btnID: string, fileName: string) => {
    const separator = apiUrl.includes("?") ? "&" : "?";
    return WebService.downloadFileAPI({
        action: apiUrl + separator + queryString,
        body: body,
        btnId: btnID,
    }).then((res: any) => {
        const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    }).catch((err: any) => {
    })
}